(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CancelarAsignacionController', CancelarAsignacionController);

    CancelarAsignacionController.$inject = ['$uibModalInstance', '$state', 'entity', 'SSAsignacion'];

    function CancelarAsignacionController($uibModalInstance, $state, entity, SSAsignacion) {
        var vm = this;

        vm.sSAsignacion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSAsignacion.cancelarAsignacion({idAsignacion: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
